import {
  SmartTable,
  SmartTableColumn,
  SmartTableDataItem,
} from '@toggle/design-system';
import React from 'react';

import * as S from './SharedTable.styles';

export interface SharedTableProps<T> {
  tableData: SmartTableDataItem<T>[];
  tableColumns: SmartTableColumn<T>[];
  title?: string;
  titleSize?: 'small' | 'large';
  noCellPadding?: boolean;
}

export const SharedTable = <T extends {}>({
  tableData,
  tableColumns,
  title,
  titleSize = 'small',
  noCellPadding = false,
}: SharedTableProps<T>) => {
  const isSmallTitle = titleSize === 'small';

  return (
    <S.Root $hasTitle={!!title} $isSmallTitle={isSmallTitle}>
      {!!title && (
        <S.TitleWrapper $isSmallTitle={isSmallTitle}>{title}</S.TitleWrapper>
      )}
      <S.SmartTableWrapper $noCellPadding={noCellPadding}>
        <SmartTable
          columns={tableColumns}
          data={tableData}
          withBodyRowHover={false}
        />
      </S.SmartTableWrapper>
    </S.Root>
  );
};
